import fetch from '@/utils/fetch'
import constants from '@/utils/constants'
// 量表列表
export function planEvaluationList(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.EVALUATION + '/plan/evaluation/list',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 测查-机构模块已购列表
export function evaluationOrganizeList(param:any) {
  return fetch({
    url: '/evaluation/organize/list',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 测查-机构模块未购列表
export function evaluationOrganizeNoList(param:any) {
  return fetch({
    url: '/evaluation/organize/noList',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 测查记录列表
export function evaluationRecordList(param:any) {
  return fetch({
    url: '/evaluation/record/list',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 测查记录新增
export function evaluationRecordAdd(param:any) {
  return fetch({
    url: '/evaluation/record/add',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 测查记录删除
export function evaluationRecordDelete(evaluationRecordId:any) {
  return fetch({
    url: constants.API_MODULE_PATH.EVALUATION + '/evaluation/record/delete',
    method: 'post',
    data: {
      evaluationRecordId
    }
  })
}

// 测查记录统计

export function evaluationRecordData(param:any) {
  return fetch({
    url: '/evaluation/record/data',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 测查记录表格详情
export function evaluationRecordForm(param:any) {
  return fetch({
    url: '/evaluation/record/form',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 测查记录提交
export function evaluationRecordSubmit(param:any) {
  return fetch({
    url: '/evaluation/record/submit',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 测查记录预览
export function evaluationRecordPreview(param:any) {
  return fetch({
    url: '/evaluation/record/preview',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 测查记录结果详情
export function evaluationRecordResult(param:any) {
  return fetch({
    url: '/evaluation/record/result',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 测查记录首页折线统计
export function evaluationRecordIndexData(param:any) {
  return fetch({
    url: '/evaluation/record/indexData',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 测查记录首页折线统计
export function evaluationRecordStatistics(param:any) {
  return fetch({
    url: '/evaluation/record/statistics',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 评测模块详情
export function evaluationInfo(param:any) {
  return fetch({
    url: '/evaluation/info',
    method: 'post',
    data: {
      ...param
    }
  })
}

// ocr扫描结果详情
export function ocrrecordInfo(param:any) {
  return fetch({
    url: 'http://test.api.hospital.childfit.cn/organize/app/h5/ocrrecord/info',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 测查记录app新增测查列表
export function recordAppList(param:any) {
  return fetch({
    url: '/evaluation/record/appList',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 测查数据预览
export function recordPreviewData(param:any) {
  return fetch({
    url: '/evaluation/record/previewData',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 评测判断该档案是否可以进行此测查
export function evaluationRecordCheck(param:any) {
  return fetch({
    url: '/evaluation/record/check',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 评测记录编辑
export function evaluationRecordEdit(param:any) {
  return fetch({
    url: '/evaluation/record/edit',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 安全锁加锁
export function evaluationRecordLock(param:any) {
  return fetch({
    url: '/evaluation/record/lock',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 安全锁解锁
export function evaluationRecordUnlock(param:any) {
  return fetch({
    url: '/evaluation/record/unlock',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 安全锁状态
export function evaluationRecordLockStatus(param:any) {
  return fetch({
    url: '/evaluation/record/lockStatus',
    method: 'post',
    data: {
      ...param
    }
  })
}

// 拒绝
export function evaluationRecordRefuse(param:any) {
  return fetch({
    url: '/evaluation/record/refuse',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 评测记录生成报告
export function evaluationRecordPass(param:any) {
  return fetch({
    url: '/evaluation/record/pass',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 可用授权次数
export function evaluationRecordAmount(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.EVALUATION + '/evaluation/record/amount',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 测评记录详情
export function evaluationRecordInfo(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.EVALUATION + '/evaluation/record/info',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 打印报告
export function printResult(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.EVALUATION + '/evaluation/record/print/result',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 下载pdf报告
export function printPdf(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.EVALUATION + '/evaluation/record/print/pdf',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 更新
export function evaluationUpdate(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.EVALUATION + '/evaluation/record/update',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 取消更新
export function evaluationCancelupdate(param:any) {
  return fetch({
    url: constants.API_MODULE_PATH.EVALUATION + '/evaluation/record/cancelupdate',
    method: 'post',
    data: {
      ...param
    }
  })
}
// 删除报告
export function resultDelete(evaluationRecordId:any) {
  return fetch({
    url: constants.API_MODULE_PATH.EVALUATION + '/evaluation/record/result/delete',
    method: 'post',
    data: {
      evaluationRecordId
    }
  })
}
// 学生列表
export function resultStudents(evaluationRecordId:any) {
  return fetch({
    url: constants.API_MODULE_PATH.EVALUATION + '/evaluation/record/students',
    method: 'post',
    data: {
      evaluationRecordId
    }
  })
}
// 评估列表
export function recordPlanList(evaluationRecordId:any) {
  return fetch({
    url: constants.API_MODULE_PATH.EVALUATION + '/evaluation/record/plan/list',
    method: 'post',
    data: {
      evaluationRecordId
    }
  })
}

// 班级列表
export function planClassrooms(evaluationRecordId:any) {
  return fetch({
    url: '/api-evaluation/admin/plan/classrooms',
    method: 'post',
    data: {
      evaluationRecordId
    }
  })
}

export function exportData(param:any) {
  return fetch({
    url: '/api-evaluation/admin/evaluation/record/export',
    method: 'post',
    data: {
      ...param
    }
  })
}
export function exportDataNew(param:any) {
  return fetch({
    url: '/api-evaluation/admin/evaluation/record/exportNew',
    method: 'post',
    data: {
      ...param
    }
  })
}
export function getUseReport(param:any) {
  return fetch({
    url: '/api-evaluation/admin/evaluation/record/checkEnableAmountByViewTimes',
    method: 'post',
    data: {
      ...param
    }
  })
}
